import { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api';
import { explorerTxUrl } from '../network';

function Distribute() {
    const [address, setAddress] = useState('');
    const [amount, setAmount] = useState('');
    const [status, setStatus] = useState(null); // null | 'loading' | 'success' | 'error'
    const [txHash, setTxHash] = useState('');
    const [errorMsg, setErrorMsg] = useState('');

    const handleSend = async (e) => {
        e.preventDefault();
        setStatus('loading');
        setErrorMsg('');

        try {
            const res = await api.post('/distribute', {
                recipientAddress: address.trim(),
                amount: parseFloat(amount),
            });
            setTxHash(res.data.txHash);
            setStatus('success');
        } catch (err) {
            setErrorMsg(err.response?.data?.error || 'Transaction failed. Please try again.');
            setStatus('error');
        }
    };

    return (
        <div style={{
            minHeight: '100vh',
            background: 'linear-gradient(180deg, #12121a 0%, #1a1a2e 50%, #12121a 100%)',
            color: '#ffffff',
            position: 'relative',
            overflow: 'hidden',
        }}>
            {/* Decorative gradient orbs */}
            <div style={{
                position: 'fixed',
                top: '-20%',
                right: '-10%',
                width: '500px',
                height: '500px',
                background: 'radial-gradient(circle, rgba(255, 193, 7, 0.12) 0%, transparent 70%)',
                borderRadius: '50%',
                pointerEvents: 'none',
                zIndex: 0,
            }} />
            <div style={{
                position: 'fixed',
                bottom: '-30%',
                left: '-10%',
                width: '400px',
                height: '400px',
                background: 'radial-gradient(circle, rgba(255, 193, 7, 0.08) 0%, transparent 70%)',
                borderRadius: '50%',
                pointerEvents: 'none',
                zIndex: 0,
            }} />

            <div style={{
                padding: '32px 24px',
                maxWidth: '500px',
                margin: '0 auto',
                position: 'relative',
                zIndex: 1,
            }}>
                {/* Page Header */}
                <div style={{ marginBottom: '32px' }}>
                    <h1 style={{
                        fontSize: '2rem',
                        fontWeight: 700,
                        marginBottom: '8px',
                        background: 'linear-gradient(135deg, #ffffff 0%, rgba(255, 255, 255, 0.7) 100%)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        backgroundClip: 'text',
                    }}>
                        Distribute Funds
                    </h1>
                    <p style={{ color: 'rgba(255, 255, 255, 0.6)', fontSize: '0.95rem', margin: 0 }}>
                        Send SOL to any wallet address on Solana Devnet
                    </p>
                </div>

                <form
                    onSubmit={handleSend}
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '24px',
                        background: 'rgba(255, 255, 255, 0.03)',
                        border: '1px solid rgba(255, 255, 255, 0.08)',
                        borderRadius: '20px',
                        backdropFilter: 'blur(20px)',
                        padding: '28px',
                    }}
                >
                    <div>
                        <label style={{
                            display: 'block',
                            fontWeight: 600,
                            marginBottom: '8px',
                            color: '#ffffff',
                            fontSize: '0.9rem',
                        }}>
                            Recipient Wallet Address
                        </label>
                        <input
                            type="text"
                            value={address}
                            onChange={(e) => setAddress(e.target.value)}
                            placeholder="e.g. Fg6Pa..."
                            required
                            style={{
                                width: '100%',
                                padding: '14px 16px',
                                borderRadius: '12px',
                                border: '1px solid rgba(255, 255, 255, 0.1)',
                                background: 'rgba(255, 255, 255, 0.05)',
                                color: '#ffffff',
                                fontSize: '0.95rem',
                                boxSizing: 'border-box',
                                outline: 'none',
                                transition: 'border-color 0.2s, background 0.2s',
                            }}
                            onFocus={e => {
                                e.target.style.borderColor = 'rgba(255, 193, 7, 0.5)';
                                e.target.style.background = 'rgba(255, 255, 255, 0.08)';
                            }}
                            onBlur={e => {
                                e.target.style.borderColor = 'rgba(255, 255, 255, 0.1)';
                                e.target.style.background = 'rgba(255, 255, 255, 0.05)';
                            }}
                        />
                    </div>

                    <div>
                        <label style={{
                            display: 'block',
                            fontWeight: 600,
                            marginBottom: '8px',
                            color: '#ffffff',
                            fontSize: '0.9rem',
                        }}>
                            Amount (SOL)
                        </label>
                        <input
                            type="number"
                            value={amount}
                            onChange={(e) => setAmount(e.target.value)}
                            placeholder="0.00"
                            required
                            min="0.000000001"
                            step="any"
                            style={{
                                width: '100%',
                                padding: '14px 16px',
                                borderRadius: '12px',
                                border: '1px solid rgba(255, 255, 255, 0.1)',
                                background: 'rgba(255, 255, 255, 0.05)',
                                color: '#ffffff',
                                fontSize: '0.95rem',
                                boxSizing: 'border-box',
                                outline: 'none',
                                transition: 'border-color 0.2s, background 0.2s',
                            }}
                            onFocus={e => {
                                e.target.style.borderColor = 'rgba(255, 193, 7, 0.5)';
                                e.target.style.background = 'rgba(255, 255, 255, 0.08)';
                            }}
                            onBlur={e => {
                                e.target.style.borderColor = 'rgba(255, 255, 255, 0.1)';
                                e.target.style.background = 'rgba(255, 255, 255, 0.05)';
                            }}
                        />
                    </div>

                    <button
                        type="submit"
                        disabled={status === 'loading'}
                        style={{
                            width: '100%',
                            padding: '14px 24px',
                            borderRadius: '12px',
                            border: 'none',
                            background: status === 'loading'
                                ? 'rgba(255, 193, 7, 0.5)'
                                : 'linear-gradient(135deg, #ffc107 0%, #ff9800 100%)',
                            color: '#000',
                            fontWeight: 700,
                            fontSize: '0.95rem',
                            cursor: status === 'loading' ? 'not-allowed' : 'pointer',
                            boxShadow: '0 4px 20px rgba(255, 193, 7, 0.3)',
                            transition: 'all 0.2s ease',
                        }}
                    >
                        {status === 'loading' ? 'Processing on Solana…' : 'Send Funds'}
                    </button>
                </form>

                {/* Success Message */}
                {status === 'success' && (
                    <div style={{
                        marginTop: '24px',
                        padding: '16px 20px',
                        background: 'rgba(34, 197, 94, 0.15)',
                        border: '1px solid rgba(34, 197, 94, 0.3)',
                        borderRadius: '12px',
                        color: '#22c55e',
                    }}>
                        <strong>Transfer Complete!</strong><br />
                        <a
                            href={explorerTxUrl(txHash)}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: '#22c55e', fontSize: '0.8rem', wordBreak: 'break-all' }}
                        >
                            View on Solana Explorer ↗
                        </a>
                    </div>
                )}

                {/* Error Message */}
                {status === 'error' && (
                    <div style={{
                        marginTop: '24px',
                        padding: '16px 20px',
                        background: 'rgba(239, 68, 68, 0.15)',
                        border: '1px solid rgba(239, 68, 68, 0.3)',
                        borderRadius: '12px',
                        color: '#ef4444',
                    }}>
                        <strong>Transfer Failed.</strong> {errorMsg}
                    </div>
                )}

                <Link
                    to="/"
                    style={{
                        display: 'inline-block',
                        marginTop: '28px',
                        color: 'rgba(255, 255, 255, 0.6)',
                        fontSize: '0.9rem',
                        textDecoration: 'none',
                        transition: 'color 0.2s',
                    }}
                    onMouseEnter={e => e.target.style.color = '#ffc107'}
                    onMouseLeave={e => e.target.style.color = 'rgba(255, 255, 255, 0.6)'}
                >
                    ← Back to Dashboard
                </Link>
            </div>
        </div>
    );
}

export default Distribute;
